import { EventEmitter, OnInit, } from '@angular/core';
import { AppStateFacade } from '@app-state';
import { combineLatest, Observable, } from 'rxjs';
import { map } from 'rxjs/operators';
var UiLanguageSelectorComponent = /** @class */ (function () {
    function UiLanguageSelectorComponent(_appState) {
        this._appState = _appState;
        this.change = new EventEmitter();
    }
    UiLanguageSelectorComponent.prototype.ngOnInit = function () {
        this.currentLanguage$ =
            combineLatest([
                this.languages$,
                this._appState.language.value$,
            ]).pipe(map(function (_a) {
                var languages = _a[0], currentLanguageIdentifier = _a[1];
                return languages.find(function (lang) { return lang.Name === currentLanguageIdentifier; });
            }));
    };
    UiLanguageSelectorComponent.prototype.changeLanguage = function (language) {
        this.change.emit(language.Name);
    };
    return UiLanguageSelectorComponent;
}());
export { UiLanguageSelectorComponent };
